import { BuildingDTO } from "./building";
import { UnitDTO } from "./unit";

export enum EmergencyLightingOnEveryFloorStatus {
  OK = 'Aanwezig',
  PARTIAL = 'Gedeeltelijk aanwezig',
  NOT_REQUIRED = 'Niet nodig',
  NOT_OK = 'Niet aanwezig',
  UNKNOWN = "Niet nagekeken"
}

export enum FireExtinguisherOnEveryFloorStatus {
  OK = 'Aanwezig',
  PARTIAL = 'Gedeeltelijk aanwezig',
  NOT_OK = 'Niet aanwezig',
  UNKNOWN = "Niet nagekeken"
}

export enum FireStairStatus {
  OK = 'Aanwezig',
  NOT_OK = 'Verplicht, en niet aanwezig',
  NOT_REQUIRED = 'Geen brandtrap verplicht',
  UNKNOWN = "Niet nagekeken"
}


export enum FireProofDoorsStatus {
  OK = 'Aanwezig',
  NOT_OK = 'Niet aanwezig',
  NOT_REQUIRED = 'Niet verplicht',
  UNKNOWN = "Niet nagekeken"
}

export enum FireEvacuationStatus {
  OK = 'Aanwezig',
  PARTIAL = 'Gedeeltelijk aanwezig',
  NOT_OK = 'Niet aanwezig',
  NOT_REQUIRED = 'Geen pictogrammen verplicht',
  UNKNOWN = "Niet nagekeken"
}

export enum SmokeDetectorsOnEveryFloorStatus {
  OK = 'Aanwezig',
  PARTIAL = 'Gedeeltelijk aanwezig',
  NOT_OK = 'Niet aanwezig',
  UNKNOWN = "Niet nagekeken"
}

export enum FireExtinguisherInElevatorRoomStatus {
  OK = 'Aanwezig',
  NOT_OK = 'Niet aanwezig',
  NO_ELEVATOR = 'Geen lift aanwezig',
  UNKNOWN = "Niet nagekeken"
}

export enum FireHoseReelStatus {
  OK = 'Aanwezig',
  NOT_OK = 'Niet aanwezig',
  NOT_REQUIRED = 'Geen brandhaspel verplicht',
  UNKNOWN = "Niet nagekeken"
}


export type FireSecurityBuildingInfoDto = {
  id: number;
  building: BuildingDTO;
  remarks: string
  emergencyLightingOnEveryFloorStatus: EmergencyLightingOnEveryFloorStatus;
  smokeDetectorsOnEveryFloorStatus: SmokeDetectorsOnEveryFloorStatus;
  fireExtinguisherOnEveryFloorStatus: FireExtinguisherOnEveryFloorStatus;
  fireExtinguisherInElevatorRoomStatus: FireExtinguisherInElevatorRoomStatus;
  fireProofDoors: FireProofDoorsStatus;
  fireHoseReelStatus: FireHoseReelStatus;
  fireEvacuationStatus: FireEvacuationStatus;
  fireStairStatus: FireStairStatus;
  fireSecurityLastInspectionDate: Date;
  fireSecurityNextInspectionDate: Date;
  inspectorResourceId: number;

  // Add additional fields or relations here as needed
}

export type FireSecurityUnitInfoDto = {
  id: number;
  unit: UnitDTO;
  remarks: string;
  fireProofDoors: FireProofDoorsStatus;
  smokeDetectorsOnEveryFloorStatus: SmokeDetectorsOnEveryFloorStatus;

  // Add additional fields or relations here as needed
}